import React from "react"
import { CopyRowWrapper } from "./CopyRow.styles"
import { backgroundColourFormatter } from "../Global/utils/flexipageHelpers"
import BardCopy from "../Global/BardCopy/BardCopy"

const CopyRow = ({data}) => {

    const textAlignmentValue = data.text_alignment?.value;
    const prevWidgetClass = data.addClassToPrevious ? data.addClassToPrevious : '';
    const textAlignment = textAlignmentValue === 'Center' ? ' text-center' : '';
    const bgColor = backgroundColourFormatter(data.background_colour?.value);

    return(
        <CopyRowWrapper id={data.row_id} className={`flexipage-row ${bgColor}${textAlignment}${prevWidgetClass}`} data-animation-trigger="true">
            <div className="flexipage-container" data-animation="animate__fadeIn" data-animation-duration="1s" data-animation-delay="0.1s">
                <BardCopy nodes={data.copy} />
            </div>
        </CopyRowWrapper>
    )
}

export default CopyRow;
